module.exports = __webpack_public_path__ + "img/upper_arm.149a0ca5.png";